import c1 from './c1'
import c2 from './c2'
import c3 from './c3'
import c4 from './c4'
import c5 from './c5'
import c6 from './c6'
import c7 from './c7'

export const indicadoresEsfEapConfig = {
  [c1.value]: c1,
  [c2.value]: c2,
  [c3.value]: c3,
  [c4.value]: c4,
  [c5.value]: c5,
  [c6.value]: c6,
  [c7.value]: c7,
}
